<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.11536 2.09779C5.33239 2.90807 4.42441 7.85856 7.67302 9.96179C10.4333 11.7488 14.197 9.75608 14.2967 6.45466C14.3819 3.63781 11.853 1.51139 9.11536 2.09779ZM5.95744 10.4588C3.57586 11.8481 1.99916 14.5075 2 17.1339C2.00015 17.6399 2.04638 17.7688 2.27836 17.9099C2.47587 18.03 17.5241 18.03 17.7216 17.9099C17.9512 17.7702 17.9999 17.6381 18 17.1537C18.0009 14.5074 16.4314 11.8524 14.0426 10.4588L13.7965 10.3153L13.5233 10.5387C11.4314 12.2484 8.5746 12.2482 6.47669 10.5381L6.20345 10.3153L5.95744 10.4588Z"
  />
</svg>
